import { render } from "./UserProfileView.vue?vue&type=template&id=58df1932&scoped=true"
import script from "./UserProfileView.vue?vue&type=script&lang=js"
export * from "./UserProfileView.vue?vue&type=script&lang=js"

import "./UserProfileView.vue?vue&type=style&index=0&id=58df1932&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58df1932"]])

export default __exports__